export default {"src":"/bnb/_next/static/media/metamaskwallet.84fbdbb6.svg","height":20,"width":20};